/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { tossPaymentsControllerWebhook } from '../fn/toss-payments/toss-payments-controller-webhook';
import { TossPaymentsControllerWebhook$Params } from '../fn/toss-payments/toss-payments-controller-webhook';

@Injectable({ providedIn: 'root' })
export class TossPaymentsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `tossPaymentsControllerWebhook()` */
  static readonly TossPaymentsControllerWebhookPath = '/api/toss-payments/webhook';

  /**
   * Toss Payment 웹훅.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tossPaymentsControllerWebhook()` instead.
   *
   * This method doesn't expect any request body.
   */
  tossPaymentsControllerWebhook$Response(params?: TossPaymentsControllerWebhook$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return tossPaymentsControllerWebhook(this.http, this.rootUrl, params, context);
  }

  /**
   * Toss Payment 웹훅.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tossPaymentsControllerWebhook$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tossPaymentsControllerWebhook(params?: TossPaymentsControllerWebhook$Params, context?: HttpContext): Observable<void> {
    return this.tossPaymentsControllerWebhook$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
